import { render, staticRenderFns } from "./lanternFestival.vue?vue&type=template&id=7911176b&"
import script from "./lanternFestival.vue?vue&type=script&lang=js&"
export * from "./lanternFestival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports